<template lang="pug">
.bems-event-card.z-depth-2.item.element-item.card
  .bems-card-header
    p {{ city.name }}
  .bems-card-img
    img(:src="city.cover" :alt="city.name")
  .bems-card-content
    p Settled in {{city.settled}}
    p(v-if="city.population != 'Ghost Town' &&  city.population != 'unknown'") Population: Approximately {{city.population}}
    p(v-if="city.population === 'Ghost Town'") Population: Maybe some ghosts
    p(v-if="city.population === 'unknown'") Population: Unknown
    p(v-if="city.population != 'Ghost Town'") ZIP code is {{city.zipcode}}
  .bems-card-footer.z-depth-1
    a.chip(:href="city.website" target="_blank") Website
</template>

<script>

export default{
  props: ['city'],
  data () {
    return {
      sponsor: ''
    }
  }
}
</script>

<style scoped lang="stylus">

.chip{
  background-color: #555;
  color: #fff;
}

.deal-name{
  font-weight: bold;
  font-size: x-large;
}

  .bems-event-card{
    display: flex;
    float: left;
    position: relative;
    flex-direction: column;
    justify-content: space-between;
    width: 300px;
    margin: 1em;
    border-radius: 1em;
    overflow: hidden;
    @media screen and (max-width: 350px){
      width: auto;
    }
    .bems-card-header, .bems-card-footer{
      display: flex;
      align-items: center;
      height: 50px;
      padding-left: 1em;
      h2{
        font-size: 1.5em;
        font-weight: bold;
        color: white;
        white-space: nowrap;
        }
      }
      .bems-card-content{
color: #fff;
padding: 1em;
max-height: 300px;
      }
  }
.bems-card-img{
  img{
    width: 100%;
  }
}
.bems-card-header{
  justify-content: center;
  font-weight: bold;
  font-size: 20px;
}
</style>
